var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 2.16602C5.40866 2.16602 1.66699 5.90768 1.66699 10.4993C1.66699 15.091 5.40866 18.8327 10.0003 18.8327C14.592 18.8327 18.3337 15.091 18.3337 10.4993C18.3337 5.90768 14.592 2.16602 10.0003 2.16602ZM13.9837 8.58268L9.25866 13.3077C9.14199 13.4243 8.98366 13.491 8.81699 13.491C8.65033 13.491 8.49199 13.4243 8.37533 13.3077L6.01699 10.9493C5.77533 10.7077 5.77533 10.3077 6.01699 10.066C6.25866 9.82435 6.65866 9.82435 6.90033 10.066L8.81699 11.9827L13.1003 7.69935C13.342 7.45768 13.742 7.45768 13.9837 7.69935C14.2253 7.94102 14.2253 8.33268 13.9837 8.58268Z",
    fill: "#38879F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCircle);
export default __webpack_public_path__ + "static/media/checked-circle.74bc51b38d8310b82550c46b31eaaa36.svg";
export { ForwardRef as ReactComponent };